<ts-dialog [title]="dynamicDialogTitle" (closeDialog)="discard()">
  <main ts-dialog-body class="w-full">
    <form [formGroup]="noteForm" class="add-note-form">
      <div class="note-title">
        <ts-icon class="mr-4" color="black" icon="edit"></ts-icon>
        <mat-form-field class="note-title__field treo-mat-no-subscript">
          <input matInput [formControlName]="'title'" [placeholder]="'Add a note title...'" />
        </mat-form-field>
      </div>

      <div class="associate-contacts">
        <ts-icon class="mr-4" color="black" icon="people"></ts-icon>
        <mat-form-field class="associate-contacts__field treo-mat-no-subscript">
          <mat-chip-list #chipList aria-label="User selection" class="mat-chip-list">
            @for (user of selectedUsers; track user.id) {
              <mat-chip [removable]="true" (removed)="removeUser(user)">
                {{ user.name }}
                <ts-icon matChipRemove color="black" icon="cancel"></ts-icon>
              </mat-chip>
            }
            <input
              placeholder="Associate contacts..."
              #userInput
              [formControl]="contactSearchControl"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            />
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
            @for (user of contactList; track user.id) {
              <mat-option [value]="user.name" [id]="user.id">
                {{ user.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <quill-editor
        [formControlName]="'body'"
        [modules]="quillModules"
        [mentionConfig]="mentionConfig"
        (onEditorCreated)="onEditorCreated($event)"
      ></quill-editor>
    </form>
  </main>
  <footer ts-dialog-actions class="ts-dialog-actions-container">
    <ts-button variant="secondary" (click)="discard()">Cancel</ts-button>
    <ts-button variant="primary" [disabled]="isFormDisabled()" (click)="sendAndClose()">Save</ts-button>
  </footer>
</ts-dialog>
